import { Outlet } from "react-router-dom";
export const Masters = () => {
    return (
        <Outlet />
    )
}